import type workbenchZh from '../zh/workbench';

const workbench: typeof workbenchZh = {
  funnel_detail: 'Xem chi tiết "{{label}}"',
  open_purchase: 'Mở mua gói',
  today_overview: 'Tổng quan hôm nay',
  shop_line: 'Cửa hàng {{region}} · {{name}}',
  pending_replies: 'Chờ trả lời',
  dm_chip: 'Tin nhắn {{value}}',
  email_chip: 'Email {{value}}',
  dm_quota: 'Hạn mức tin nhắn',
  invite_quota: 'Hạn mức lời mời',
  dm_quota_meta: '/ {{total}} hôm nay · còn {{remain}}',
  email_this_month: 'Email tháng này',
  unlimited: 'Không giới hạn',
  delivery_rate: 'Đã gửi {{rate}}%',
  authorized_shops: 'Cửa hàng đã ủy quyền',
  plan_expire: '{{plan}} · hết hạn {{date}}',
  plan_benefits: 'Quyền lợi gói',
  per_month: '/ tháng',
  mail_remain: 'còn {{remain}}',
  addon_included: 'gồm mua thêm {{extra}}',
  plan_quota: '{{emails}} email · {{shops}} cửa hàng',
  addon_packages: 'Gói quyền lợi mua thêm',
  addon_empty: 'Không có',
  usage_invite: 'Lời mời',
  quota_reset_time: 'Thời gian đặt lại hạn mức:',
  quota_reset_hint:
    'Đây là mốc chu kỳ hạn mức: sau khi hạn mức tháng này dùng hết, nếu đã gia hạn thì là thời điểm hạn mức mới có hiệu lực; nếu chưa gia hạn thì là thời điểm hết hạn. Khi đặt lại chu kỳ, hạn mức lời mời, tin nhắn và email sẽ được đặt lại, hạn mức cửa hàng thì không.',
  current_usage: 'Đang dùng:',
  usage_shop: 'Cửa hàng',
  usage_email: 'Email',
  email_tag: 'Email',
  usage_rest: '/ {{limit}} ( gồm mua thêm {{extra}} )',
  funnel: 'Phễu kết nối',
  funnel_load_failed: 'Không tải được phễu kết nối',
  quick_outreach: 'Kết nối nhanh',
  funnel_matchable: 'Có thể ghép',
  funnel_pool: 'Nhóm KOL',
  funnel_dm: 'Đã nhắn tin',
  funnel_dm_rate: 'Tỷ lệ chuyển đổi {{rate}}%',
  funnel_emailed: 'Đã gửi email',
  funnel_dm_to_email: 'Tin nhắn→email {{rate}}%',
  targeted_invite: 'Lời mời định hướng',
  funnel_invite_rate: 'Tỷ lệ mời {{rate}}%',
  funnel_accepted: 'Đã trả lời/đã chấp nhận',
  funnel_total_rate: 'Tỷ lệ chuyển đổi tổng {{rate}}%',
  todos: 'Việc cần làm',
  pending_dms: '{{value}} tin nhắn chờ trả lời',
  pending_dms_meta: 'Tin nhắn mới nhất do KOL gửi',
  dm_tag: 'Tin nhắn',
  pending_emails: '{{value}} email chờ trả lời',
  pending_emails_meta: 'KOL đã trả lời, đang chờ phía mình',
  handle: 'Xử lý',
  quick_entry: 'Lối tắt',
  quick_dm: 'Gửi tin nhắn',
  quick_email: 'Gửi email',
  quick_upgrade: 'Mua/Nâng cấp',
  quick_hint: 'Cửa hàng chỉ ở Đông Nam Á. Sau khi ủy quyền thành công có thể gửi tin nhắn, email và lời mời định hướng'
};

export default workbench;
